import { useSuspenseQuery } from "@tanstack/react-query";
import { Outlet } from "@tanstack/react-router";
import { Menu } from "lucide-react";
import { useState } from "react";
import logoUrl from "@/shared/assets/laget-logo-orange-big.png";
import { Button } from "@/shared/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from "@/shared/components/ui/sheet";
import { AppNav } from "./AppNav";
import { meQueryOptions } from "./api/auth.queries";
import { useLogoutFlow } from "./useLogoutFlow";

export function AppShellLayout() {
  const { data: me } = useSuspenseQuery(meQueryOptions);
  const { onLogout, isPending } = useLogoutFlow();
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <aside className="surface-header sticky top-0 hidden h-screen w-48 flex-col border-r border-border md:flex">
        <AppNav me={me} onLogout={onLogout} isPending={isPending} />
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="surface-header flex h-16 items-center gap-2 border-b border-border px-3 md:hidden">
          <Sheet open={navOpen} onOpenChange={setNavOpen}>
            <SheetTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                aria-label="Öppna meny"
                className="text-header-foreground hover:bg-foreground/10 hover:text-header-foreground"
              >
                <Menu className="size-5" />
              </Button>
            </SheetTrigger>
            {/* Solid bg-header (no sheen): SheetContent runs cn() against its own bg-background, and
                a bare bg-header reliably wins that merge — surface-header (unknown to tailwind-merge)
                wouldn't dedupe the base colour. */}
            <SheetContent
              side="left"
              aria-describedby={undefined}
              className="w-64 gap-0 border-border bg-header p-0 text-header-foreground"
            >
              <SheetTitle className="sr-only">Meny</SheetTitle>
              <AppNav
                me={me}
                onLogout={onLogout}
                isPending={isPending}
                onNavigate={() => setNavOpen(false)}
              />
            </SheetContent>
          </Sheet>
          <img src={logoUrl} alt="LAGET" className="h-10 w-auto" />
        </header>

        <main className="min-w-0 flex-1 p-4 md:min-h-screen">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
